var React = require('react');

function Exit (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1 1L13 13","strokeWidth":"1.45","key":0}),React.createElement("path",{"d":"M1 13L13 0.999999","strokeWidth":"1.45","key":1})]);
}

Exit.defaultProps = {"viewBox":"0 0 14 14","className":"fill-current stroke-current"};

module.exports = Exit;

Exit.default = Exit;
